import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import styled from "../../styled";
import { Flex } from '../Box';
import { themeLss } from "../../lss";
export var FormGroupMessage = styled.p(themeLss(function (_ref) {
  var isInvalid = _ref.isInvalid,
      disabled = _ref.disabled;
  return {
    mt: 'sm',
    mb: 'none',
    color: disabled ? 'textLight' : isInvalid ? 'danger' : 'inherit',
    textScale: 'control'
  };
}));
export var Label = styled.label(themeLss(function (_ref2) {
  var inline = _ref2.inline,
      required = _ref2.required;
  return {
    color: 'primaryLight',
    mr: 'md',
    mb: inline ? 0 : 'md',
    '&:after': required ? {
      content: '*',
      color: 'danger',
      fontWeight: 'bold',
      alignAelf: 'flex-start',
      ml: 'xxs'
    } : undefined
  };
}));
var FormControlWrapper = styled(Flex)(function (_ref3) {
  var theme = _ref3.theme,
      isInline = _ref3.isInline,
      lss = _ref3.lss;
  return "\n  padding-bottom: ".concat(lss && lss.pb ? lss.pb : theme.space.xl, ";\n  ").concat(isInline ? "\n          display: inline-flex;\n          flex-direction: row;\n          align-items: center;\n          width: 100%;\n        " : "\n          flex-direction: column;\n          flex-shrink: 0;\n        ", "\n");
});
export var FormGroup = function FormGroup(_ref4) {
  var isInvalid = _ref4.isInvalid,
      isInline = _ref4.isInline,
      id = _ref4.id,
      label = _ref4.label,
      required = _ref4.required,
      descriptionId = _ref4.descriptionId,
      description = _ref4.description,
      error = _ref4.error,
      children = _ref4.children,
      disabled = _ref4.disabled,
      labelLss = _ref4.labelLss,
      props = _objectWithoutProperties(_ref4, ["isInvalid", "isInline", "id", "label", "required", "descriptionId", "description", "error", "children", "disabled", "labelLss"]);

  var message = isInvalid && error || description;
  return React.createElement(FormControlWrapper, Object.assign({
    isInline: isInline,
    "data-invalid": isInvalid
  }, props), label && React.createElement(Label, {
    id: "".concat(id, "-label"),
    htmlFor: id,
    inline: isInline,
    required: required,
    lss: labelLss
  }, label), children, !!message && React.createElement(FormGroupMessage, {
    disabled: disabled,
    isInvalid: isInvalid,
    id: descriptionId
  }, message));
};